/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection>): BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection(), model);
        BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection>): BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.newInstance(<BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
